import React from 'react';
import Slider from "rsuite/Slider";
import 'rsuite/Slider/styles/index.css';
import TitleTooltip from "../../../components/helpers/TitleTooltip";

export default function Subtareas({
   data,
   toggleShow
}){
    function colorStatus(c){
        switch (c){
            case 1:
                return <div className="badge badge-light-success">Abierto</div>;
            case 2:
                return <div className="badge badge-light-primary">En proceso</div>;
            case 3:
                return <div className="badge badge-light-warning">En pausa</div>;
            case 4:
                return <div className="badge badge-light-danger">Validando</div>;
            case 5:
                return <div className="badge badge-light-secondary">Finalizado</div>;
            default:
                return <div className="badge badge-light-info">Abierto</div>;
        }
    }


    function selectPrioridad(p){
        switch (p) {
            case 'MA':
                return <div className={"text-danger"}><i className="bi bi-chevron-double-up mx-2 text-danger"></i> MA</div>;
            case 'A':
                return <div className={"text-info"}><i className="bi bi-chevron-up mx-2 text-info"></i> A</div>;
            case 'N':
                return <div className={"text-warning "}><i className="bi bi-dash mx-2 text-warning"></i> N</div>;
            case 'B':
                return <div className={"text-success"}><i className="bi bi-chevron-down mx-2 text-success"></i> B</div>;
            case 'MB':
                return <div className={"text-primary"}><i className="bi bi-chevron-double-down mx-2 text-primary"></i> MB </div>
            default:
                return <div className={"text-warning"}><i className="bi bi-dash mx-2 text-warning"></i> N</div>;
        }
    }
    return (
        <div className="row g-7 mt-1">
            {
                data && data.length > 0 && data.map((c) => {
                    return (
                        <div key={c.id_tarea} className="col-md-4 col-lg-12 col-xl-4">
                            <div className="card mb-6 mb-xl-9 shadow-sm">
                                <div className="card-body">
                                    <div className="d-flex flex-stack mb-3">
                                        {
                                            colorStatus(c.id_estatus)
                                        }
                                        {
                                            selectPrioridad(c.prioridad)
                                        }
                                    </div>
                                    <div className="mb-2">
                                        <button type={'button'}
                                                className="btn btn-link fs-4 fw-bold mb-1 text-gray-900 text-hover-primary text-capitalize"
                                                onClick={(event) => toggleShow(event, c.id_tarea, c.tarea)}>
                                            {c.tarea}
                                        </button>
                                    </div>
                                    <div className="fs-6 fw-semibold text-gray-600 mb-5 text-capitalize">
                                        {c.objetivo}
                                    </div>
                                    <div className={'my-3'}>
                                        <Slider readOnly defaultValue={c.progreso} min={0} step={10} max={100} graduated progress />
                                    </div>
                                    <div className="d-flex flex-stack flex-wrapr">
                                        {
                                            c.miembros && c.miembros.length > 0 && c.miembros.map((m) => {
                                                return (
                                                    <div key={m.id_miembro} className="symbol-group symbol-hover my-1">
                                                        <TitleTooltip title={m.usuario.username} placement={'top'}>
                                                            <div className="symbol symbol-35px symbol-circle">
                                                                <span className={"symbol-label bg-primary text-inverse-primary fw-bold " + m.usuario.avatar}>{m.usuario.avatar}</span>
                                                            </div>
                                                        </TitleTooltip>
                                                    </div>
                                                );
                                            })
                                        }

                                        <div className="d-flex my-1">
                                            <div
                                                className="border border-dashed border-gray-300 rounded d-flex align-items-center py-2 px-3">
                                                <i className="ki-duotone ki-paper-clip fs-3"></i>
                                                <span className="ms-1 fs-7 fw-bold text-gray-600">{c.archivos_adjuntos && c.archivos_adjuntos.length}</span>
                                            </div>
                                            <div
                                                className="border border-dashed border-gray-300 d-flex align-items-center rounded py-2 px-3 ms-3">
                                                <i className="ki-duotone ki-message-text-2 fs-3">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                                <span className="ms-1 fs-7 fw-bold text-gray-600">{c.comentario && c.comentarios.length}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
}
